import {useState} from 'react';
import Card from "../Card";
import './resume.css';


const Resume = () => {

  const [educaton, setEducation] = useState([
    {
      dates: "Batch of 2025",
      title: "B.Tech, Computer Science Engineering",
      subtitle: "RTU, Kota",
      description: "CGPA: 8.01"
    },
    {
      dates: "Batch of 2020",
      title: "Grade XII",
      subtitle: "Gyanasthali School, Gaya",
      description: "Percentage: 85%"
    },
    {
      dates: "Batch of 2018",
      title: "Grade X",
      subtitle: "Manav Bharti National School, Kendui, Gaya",
      description: "Percentage: 86%"
    },
  ]);


  const [experience, setExperience] = useState([
      {
        dates: "August 2023 - September 2023",
        title: "Full Stack Development(MERN) Intern",
        subtitle: "Learn and Build, Jaipur",
        description: "Over the course of my internship, I've gained substantial expertise in ReactJs, NodeJs, ExpressJs, and MongoDB, which has transformed me into a well-rounded developer. In ReactJs, I mastered the art of building interactive user interfaces, ensuring a seamless and engaging user experience. MongoDB allowed me to dive into the world of NoSQL databases, enabling me to efficiently manage and store data. NodeJs and ExpressJs provided me with the tools to develop scalable and high-performance server-side applications, facilitating seamless communication between the front and back ends."
    },

      {
        dates: "May 2023 - July 2023",
        title: "Cloud Computing Intern",
        subtitle: "Learn and Build, Jaipur",
        description: "During the internship, I developed expertise in Linux, becoming adept at managing server environments and ensuring their security and stability. Docker and Kubernetes allowed me to delve into containerization and orchestration, enabling efficient application deployment and scaling. AWS empowered me to harness the full potential of cloud resources, architecting scalable and cost-effective solutions. Additionally, I learned the importance of automation and continuous integration/continuous deployment (CI/CD) pipelines through tools like Jenkins and Ansible."
      },
      {
        dates: "November 2022 - Present",
        title: "Teaching Assistant",
        subtitle: "Coder's Cafe (College's Coding Club)",
        description: "Assisting juniors in Java/C++ and  Web Development. Mentoring over 50+ individuals."
      },
    ]);
  
    
  
    const [Certificates, setCertificates] = useState([
      {
        dates: "September 2023",
        title: "Flutter Development Certificate",
        subtitle: "Udemy",
        description: "Earned a certification in Flutter Development from Udemy, highlighting proficiency in crafting robust and dynamic cross-platform mobile applications. Demonstrated mastery in Flutter framework, ensuring the delivery of visually appealing and high-performance mobile solutions."
      },
      {
        dates: "August 2023",
        title: "UI/UX Figma",
        subtitle: "Udemy",
        description: "Secured a UI/UX Figma Certificate from Udemy, substantiating proficiency in Figma for designing intuitive and visually compelling user interfaces. Applied learned principles to enhance user experience, ensuring a skillful blend of aesthetics and usability in digital design."
      },
      {
        dates: "May 2023",
        title: "JavaScript Algorithms and Data Structures",
        subtitle: "Udemy",
        description: "Earned a certification in JavaScript Algorithms and Data Structures from Udemy, highlighting proficiency in implementing advanced algorithms and manipulating data structures. Demonstrated a comprehensive understanding of JavaScript's core principles through rigorous coursework and practical assessments."
      },
      
      {
        dates: "February 2023",
        title: "Python Certificate",
        subtitle: "GeeksforGeeks",
        description: "Attained a Python Certificate from GeeksforGeeks, validating proficiency in Python programming language fundamentals. Demonstrated competence in Python through completion of comprehensive coursework and assessments."
      },
      
      {
        dates: "December 2022",
        title: "Problem Solving Certificate",
        subtitle:"HackerRank",
        description: "This certification has been instrumental in expanding my problem-solving toolkit, enabling me to approach diverse challenges with a more systematic and structured mindset."
      },
      {
        dates: "November 2022",
        title: "C++ Certificate",
        subtitle: "GeeksforGeeks",
        description: "Received a C++ Certificate from GeeksforGeeks, where i learnt and applied key C++ concepts, including data types, control structures, functions, classes, and object-oriented programming principles."
      },
      { 
        dates: "September 2022",
        title: "Participation Certificate",
        subtitle: "ICPC - International Collegiate Programming Contest",
        description: "Awarded a Participation Certificate in the International Collegiate Programming Contest (ICPC), showcasing dedication and proficiency in competitive programming at a global level. Demonstrated problem-solving skills and algorithmic expertise within a competitive coding environment."
      },
    ]);
  
  const [community, setCommunity] = useState([
      {
        dates: "October 2021 - Present",
        title: "Programming Languages",
        subtitle: "Dart, Java, C/C++, JavaScript, Typescript, HTML/CSS",
      description: "Demonstrating versatile expertise, I command proficiency in Dart for Flutter app development, Java for robust back-end solutions, and C/C++ for intricate system-level programming. I have strong experience with JavaScript and TypeScript, building dynamic and efficient web solutions. I also specialize in creating clean and visually appealing interfaces using HTML and CSS, ensuring smooth and engaging user experiences across different platforms."
      },
      {
        dates: "October 2021 - Present",
        title: "Libraries & Frameworks",
        subtitle: "ReactJs, NodeJs, ExpressJs, shadcnUI, MaterialUI, Ant Design, ReduxJs",
        description: "Skilled in architecting dynamic and responsive web applications with ReactJs, adeptly managing state through the strategic implementation of ReduxJs, and orchestrating seamless navigation via React Router. Accomplished in constructing robust server-side applications utilizing the power of NodeJs and ExpressJs. Proficient in curating visually compelling and user-centric interfaces, employing the design excellence of MaterialUI and Ant Design to maintain a cohesive and refined aesthetic across applications."
      },
      {
        dates: "October 2021 - Present",
        title: "Databases",
        subtitle: "MongoDB, MySQL",
        description: "Mastery in MongoDB for designing scalable NoSQL solutions, coupled with a proficiency in MySQL database management, showcasing expertise in crafting efficient relational structures and optimizing queries for robust and scalable back-end systems."
      },
      {
        dates: "October 2021 - Present",
        title: "CS Fundamentals",
        subtitle: " Object-oriented Programmnig (OOPs), Data Structures &Algorithms, Computer Networking, Database Management System (DBMS)",
        description: "Mastery in OOPs principles and data structures coupled with proficiency in advanced algorithms and a comprehensive understanding of computer networking and Database management system (DBMS)."
    },
      {
        dates: "October 2021 - Present",
        title: "Developer Tools",
        subtitle: "Git, Docker, VS Code, IntelliJ, Android Studio",
        description: "Proficient in version control using Git, adept at containerization with Docker, and skilled in utilizing development environments such as Visual Studio Code and IntelliJ for efficient coding and debugging. Additionally, experienced in Android Studio for mobile application development, demonstrating a comprehensive toolset proficiency crucial for streamlined and collaborative software development processes."
    },
      {
        dates: "October 2021 - Present",
        title: "Familiar Skills",
        subtitle: "Flutter, Firebase, Figma, Linux, Docker, Kubernetes, Amazon Web Services (AWS)",
        description: "Mastery in Flutter for cross-platform app development, Firebase for real-time database integration, and collaborative design using Figma; proficiency in Linux, Docker, Kubernetes, and AWS for architecting scalable cloud solutions."
    },
      
    ]);


    return (
      <div className="col-grid">
        
        <div className="col">
          <h1>Education</h1>
          <Card cardInfo={educaton}/>
        </div>
        
        <div className="col">
          <h1>Experience</h1>
          <Card cardInfo={experience}/>
        </div>

        <div className="col">
          <h1>Certificates</h1>
          <Card cardInfo={Certificates}/>
        </div>

        <div className="col">
          <h1>Technical Skills</h1>
          <Card cardInfo={community}/>
        </div>
        
      </div>

    )
}

export default Resume